import { Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import SelectRecepient from "./pages/select-recepient";
import Emailtemplate from "./pages/email-template";
import Campaigns from "./pages/campaigns";
import CreateCampaign from "./pages/create-campaign";
import Contacts from "./pages/contacts";
import Groups from "./pages/groups";
import TapBuilder from "./pages/tap-builder";
import UnAuthorized from "./pages/un-authorize";

export default function RoutesComponents() {
  // useEffect(() => {
  //   const storedToken = localStorage.getItem("token");
  //   if (storedToken) {
  //     checkUser(storedToken);
  //   } else if (token) {
  //     localStorage.setItem("token", token);
  //     checkUser(token);
  //   } else {
  //     navigate("/401");
  //   }
  // }, []);

  // const checkUser = (token) => {
  //   supabase.auth
  //     .getUser(token)
  //     .then((e) => {
  //       if (e?.data?.user !== null) {
  //         setUser(e?.data?.user);
  //         const newUrl = "/";
  //         navigate(newUrl, { replace: true });
  //       } else {
  //         navigate("/401");
  //       }
  //     })
  //     .catch((err) => {
  //       navigate("/401");
  //     });
  // };

  return (
    <>
      <Routes>
        <>
          <Route path="/editor" element={<Home />} />
          <Route path="/tap-builder" element={<TapBuilder />} />
          <Route path="/select-recepient" element={<SelectRecepient />} />
          <Route path="/create-campaign" element={<CreateCampaign />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/groups" element={<Groups />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/" element={<Emailtemplate />} />
        </>

        <Route path="/401" element={<UnAuthorized />} />
      </Routes>
    </>
  );
}
